import React from "react"
import {
  Box,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material"
import PropTypes from "prop-types"
import { CloudUpload as CloudUploadIcon, InsertDriveFile as InsertDriveFileIcon } from "@mui/icons-material"

const ImageUploadListView = ({ acceptedFiles }) => {
  return (
    <Box sx={{ flex: 1, display: "flex", flexDirection: "column", overflow: "hidden", px: 2, py: 2 }}>
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            minHeight: 0,
          }}
        >
          <CloudUploadIcon
            sx={{
              fontSize: 80,
              color: "grey.400",
              mb: 1,
            }}
          />
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: "center", mb: 0.5 }}
          >
            PNG形式の画像をアップロードしてください。
          </Typography>
        </Box>
        {acceptedFiles?.length > 0 && (
          <Box sx={{ flex: 1, minHeight: 0, overflow: "auto", mt: 1 }}>
            <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
              選択されたファイル（{acceptedFiles.length}件）
            </Typography>
            <List dense disablePadding sx={{ bgcolor: "grey.100", borderRadius: 1 }}>
              {acceptedFiles.map((f, i) => (
                <ListItem key={i} divider={i < acceptedFiles.length - 1}>
                  <ListItemIcon sx={{ minWidth: 36 }}>
                    <InsertDriveFileIcon color="action" fontSize="small" />
                  </ListItemIcon>
                  <ListItemText primary={f.name} primaryTypographyProps={{ variant: "body2" }} />
                </ListItem>
              ))}
            </List>
          </Box>
        )}
    </Box>
  )
}

ImageUploadListView.propTypes = {
  acceptedFiles: PropTypes.arrayOf(PropTypes.object),
}

export default ImageUploadListView
